declare namespace $ {

	export class $mol_icon_language_javascript extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=javascript.view.tree.d.ts.map